import { createRouter, createWebHashHistory } from 'vue-router';
import { routes } from '@/router/routes';
import { installAuthGuard } from '@/router/guards';

// Hash history preserves URL compatibility with the legacy AngularJS client
// (`/#/...`) — important so existing bookmarks and shared links keep working
// at cutover. Switch to web history if/when that's no longer a concern.
export const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

installAuthGuard(router);
